import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-61cc42e9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "title mb-4" }
const _hoisted_2 = { class: "description mb-4" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spinner-box" }, [
  /*#__PURE__*/_createElementVNode("lukso-icon", {
    name: "progress-indicator",
    size: "x-large"
  })
], -1 /* HOISTED */))

import Modal from '@/popup/components/shared/Modal/Modal'

export default /*#__PURE__*/_defineComponent({
  __name: 'UploadingToIpfs',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Modal).Wrapper, {
    class: "p-6",
    "data-testid": "modal-info"
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Modal).Background, { class: "darker blurry" }),
      _createVNode(_unref(Modal).Content, { class: "wider" }, {
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('modal.uploading_image.title')), 1 /* TEXT */),
            _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('modal.uploading_image.description')), 1 /* TEXT */),
            _hoisted_3
          ])
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _: 1 /* STABLE */
  }))
}
}

})